import { useLingui } from '@lingui/react/macro';

import Toggle from '@/design_system/Toggle';
import { TEMPORARY_ID_PREFIX, useUpdateDefect } from '@/models/article';
import { ArticleDefectWithRelations } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { getEditedFields } from './getEditedFields';

export const ToBeRepairedToggle = ({
  defect,
  previousDefect,
}: {
  defect?: ArticleDefectWithRelations;
  previousDefect?: ArticleDefectWithRelations;
}) => {
  const { t } = useLingui();
  const { article, request, view, errors } = useArticleContext();

  const { mutate: updateDefect } = useUpdateDefect({
    requestId: request.id,
    articleId: article.id,
  });

  const isEditable =
    !!defect &&
    view.defects.fields.toBeRepaired.editable &&
    !defect.id.startsWith(TEMPORARY_ID_PREFIX);

  const isEdited = getEditedFields({
    defect,
    previousDefect,
  }).isToBeRepairedEdited;

  const wrapperStyles = {
    backgroundColor: isEdited ? 'var(--color-tertiary-100)' : undefined,
  };

  const defectOrPreviousDefect = defect ?? previousDefect;

  if (!defectOrPreviousDefect) {
    return null;
  }

  const isDefectMissingActions = errors.defects?.defects?.find(
    (_defect) => _defect.id === defect?.id
  )?.missingActions;

  return (
    <div style={wrapperStyles}>
      <Toggle
        label={t({
          id: 'defect-card.to-be-repaired-toggle.label',
          message: 'To be repaired',
        })}
        alignment="left"
        isSelected={defectOrPreviousDefect.toBeRepaired}
        onChange={(toBeRepaired) => {
          if (defect) {
            updateDefect({
              defectId: defect.id,
              body: {
                toBeRepaired,
              },
            });
          }
        }}
        isDisabled={!isEditable}
        isInvalid={isDefectMissingActions}
      />
    </div>
  );
};
